import { Link as RouterLink } from 'react-router-dom';
// react
import { useEffect } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Button, Container } from '@mui/material';
// components
import {
  HeroWidget,
  AboutWidget,
  CourseWidget,
  GoogleTestimonials,
  SuccessStories,
  FeatureHWidget,
  AchieversWidget,
  ContactFormWidget,
  BenfitWidget,
  ServiceListWidget,
} from '../../sections/web/home';

import { SectionHeader } from '../../sections/web/common';
import { TeamWidget } from '../../sections/web/teams';
import { Seo } from '../../components/seo';
// redux
import { useDispatch } from '../../redux/store';
import { getHomeBundle } from '../../redux/slices/homeBundle';

const CenterBox = styled(Box)({
  width: '100%',
  flexDirection: 'row',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
// ----------------------------------------------------------------------

export default function HomePage() {
  const dispatch = useDispatch();

  // One request for courses, achievers, teams, and google_reviews instead of
  // four, each already sliced to the cap the widget applies to itself. The
  // widgets that consume it pass `skipFetch` below so they do not also fire
  // their own request.
  //
  // Safe to run unconditionally: `getHomeBundle` fills only the sections that
  // are still empty, so returning to the homepage after /courses or /team does
  // not overwrite the fuller lists those pages loaded, and if the bundle
  // request fails it falls back to the original endpoints.
  useEffect(() => {
    dispatch(getHomeBundle());
  }, [dispatch]);

  return (
    <>
      <Seo
        title="Healthcare Licensing Exam Preparation in UAE"
        description="ASAP UAE prepares healthcare professionals for DHA, MOH and HAAD licensing exams with expert trainers, study material, practice questions and online classes."
        path="/"
      />
      <HeroWidget sx={{ px: 0, mx: 0 }} />

      <Container maxWidth="xl">
        <ServiceListWidget />

        <AboutWidget />

        <Box component="section" sx={{ py: { xs: 5, md: 8 } }}>
          <SectionHeader
            eyebrow="Our courses"
            title="Explore Courses"
            description="Pick a programme, pick a batch, and get exam-ready with structured study material and live support."
          />

          <CourseWidget skipFetch />

          <CenterBox>
            <Box sx={{ flexGrow: 1 }} />
            <Button
              to="/courses"
              size="large"
              variant="contained"
              component={RouterLink}
              sx={{ my: 3, px: 4, whiteSpace: 'nowrap' }}
            >
              VIEW ALL COURSES
            </Button>
            <Box sx={{ flexGrow: 1 }} />
          </CenterBox>
        </Box>

        <FeatureHWidget />

        <GoogleTestimonials skipFetch />
        <SuccessStories />
        <AchieversWidget skipFetch />

        <BenfitWidget />

        <Box component="section" sx={{ py: { xs: 5, md: 8 } }}>
          <TeamWidget isSlice skipFetch />
        </Box>

        <ContactFormWidget />
      </Container>
    </>
  );
}
